const companyInvitationStatuses = ["pending", "accepted", "rejected"];
const CompanyInvitationErrorCode = {
  NO_EMAIL_MATCH: "no_email_match",
  EXPIRED: "expired",
  NOT_FOUND: "not_found",
  ALREADY_JOINED: "already_joined"
};
export {
  CompanyInvitationErrorCode
};
//# sourceMappingURL=companyInvitation.js.map
